"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.componentOrder = componentOrder;
exports.componentOrderFromFormatString = componentOrderFromFormatString;
exports.defaultFormatString = defaultFormatString;

var _uiwidgetsCommon = require("uiwidgets-common");

var defaultComponentOrder = componentOrderFromFormatString(defaultFormatString());

/**
 * Get/set the default component order.
 *
 * @param order {Array} an array that defines the date component order. e.g. ["d", "m", "y"]
 * @returns {Array} the array that defines the date component order.
 */
function componentOrder(order) {
    if ((0, _uiwidgetsCommon.isUndefined)(order)) {
        return defaultComponentOrder;
    }

    return defaultComponentOrder = order;
};

/**
 * Determine the order of date components expected for when parsing dates for the locale.
 *
 * @param formatString {String} a date format string. e.g. "dd/MM/yyyy"
 * @return {Array} an ordered array of the date component tokens. e.g. ["M", "D", "Y"];
 */
function componentOrderFromFormatString(formatString) {
    var order = [];

    order[0] = { token: "d", index: formatString.indexOf("d") };
    order[1] = { token: "m", index: formatString.indexOf("m") };
    order[2] = { token: "y", index: formatString.indexOf("y") };

    order.sort(function (l, r) {
        return l.index - r.index;
    });

    return order.map(function (item) {
        return item.token;
    });
};

/**
 * Generate a default format string, using Date.prototype.toLocaleDateString.
 *
 * @returns {String} the format string e.g. "d/m/y"
 */
function defaultFormatString() {
    var date = new Date(2016, 11, 31),
        dateString = date.toLocaleDateString();

    dateString = dateString.replace("31", "d");
    dateString = dateString.replace("12", "m");
    dateString = dateString.replace("2016", "y");
    dateString = dateString.replace("16", "y");

    return dateString;
};
//# sourceMappingURL=DateComponentOrder.js.map